import { IEnhancer, Fetcher } from '.';

export class AutomationFetchHookEnhancer implements IEnhancer {
  public enhance = (url: string, init: RequestInit, innerFetch: Fetcher) => (window as any).fetchHook
    ? (window as any).fetchHook(url, init)
    : innerFetch(url, init)
}
